import { render, staticRenderFns } from "./Alimentation.vue?vue&type=template&id=7ebed880&scoped=true&"
import script from "./Alimentation.vue?vue&type=script&lang=ts&"
export * from "./Alimentation.vue?vue&type=script&lang=ts&"
import style0 from "./Alimentation.vue?vue&type=style&index=0&id=7ebed880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebed880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
